module.exports = __webpack_public_path__ + "static/media/completed.40975921.jpg";